import React from 'react'

const Unauthorized = (props) => {
      return (
      <div className="container">
        <div className="row">
          <div className="cb-panel-white">
            <div className="col-xs-12">
              <div className="alert-danger" role="alert">
                <h4>User not Authorized for Bulk Upload. Please try with other eligible users.</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default Unauthorized